enum SnapPosition {
    TOP = 'TOP',
    RIGHT = 'RIGHT',
    BOTTOM = 'BOTTOM',
    LEFT = 'LEFT',
    CENTER = 'CENTER'
}

export default SnapPosition;
